module.exports = {
      id: "comm-health-usage",
      viewBox: "0 0 321.539 50.773",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#comm-health",
      toString: function () {
        return this.url;
      }
    }